var $ = require('jquery');
var slick = require('slick-carousel');

module.exports = {
	init: function () {
		var slider = $('.layout.media-slider .media-slider-items-inner');
		if (slider.length > 0) {
			for (var i = 0; i < slider.length; i++) {
				var $currentSlider = $(slider[i]);
				var $sliderContainer = $currentSlider.closest('.media-slider-items-inner');
				var $slideCounter = $sliderContainer.find('.slide').length;
				var showArrows = $slideCounter > 1;
				var initialSlide = !showArrows || $slideCounter == 2 ? 0 : 1;
				var prevArrow = showArrows ? $sliderContainer.parent().find('.slick-prev') : null;
				var nextArrow = showArrows ? $sliderContainer.parent().find('.slick-next') : null;
				// remove slider controls if only one slide
				if (!showArrows) {
					$sliderContainer.parent().find('.slider-controls').remove();
				}

				// Toggle some classes to create the center mode circular effect
				$currentSlider.on('init', function (event, slick) {
					$('.slick-current').prev().addClass('prev-slide');
					$('.slick-current').next().addClass('next-slide');
				});
				$currentSlider.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
					$('.slick-slide').removeClass('prev-slide next-slide');
				});
				$currentSlider.on('afterChange', function (event, slick, currentSlide) {
					// Add classes after the slide has changed
					$('.slick-current').prev().addClass('prev-slide');
					$('.slick-current').next().addClass('next-slide');
				});
				// Init slider with responsive settings
				$currentSlider.slick({
					dots: true,
					infinite: false,
					initialSlide: initialSlide,
					arrows: showArrows,
					centerMode: true,
					speed: 500,
					slidesToShow: 1,
					slidesToScroll: 1,
					centerPadding: '190px',
					appendDots: $sliderContainer.parent().find('.slick-dots-wrapper'),
					prevArrow: prevArrow,
					nextArrow: nextArrow,
					responsive: [
						{
							breakpoint: 768,
							settings: {
								centerPadding: '100px',
							},
						},
						{
							breakpoint: 640,
							settings: {
								centerPadding: '50px',
							},
						},
						{
							breakpoint: 480,
							settings: {
								centerPadding: '0px',
								centerMode: false,
							},
						},
					],
				});
			}
		}
	},
};
